// Style dùng chung giữa các bảng điều khiển.
//
// Gom về một chỗ để nút bấm và chip ở thanh hiệu ứng, bảng hình dán và bảng
// cài đặt chụp trông giống hệt nhau — trước đây mỗi file tự khai báo một bản
// sao nên rất dễ lệch nhau khi sửa.

export const buttonStyle = {
    // Bề rộng co theo màn hình: nhỏ gọn trên điện thoại, thoáng hơn trên desktop.
    padding: "clamp(8px, 2.4vw, 10px) clamp(14px, 4vw, 20px)",
    fontSize: "clamp(16px, 4.4vw, 20px)",
    cursor: "pointer",
    fontFamily: "Broline",
    color: "#8c5b4a",
    border: "2px solid #8c5b4a",
    borderRadius: 10,
    background: "white",
    transition: "transform 0.12s ease, box-shadow 0.12s ease"
};

// Nút hành động chính (Chụp / Tải xuống): tô hồng nổi bật để tách khỏi các nút
// phụ dạng viền trắng.
export const primaryButton = {
    ...buttonStyle,
    color: "white",
    border: "2px solid #ff7aa2",
    background: "#ff7aa2",
    boxShadow: "0 6px 16px rgba(255,122,162,0.35)"
};

// Tiêu đề của thanh Hiệu ứng / Hình dán nằm trực tiếp trên nền maroon tối (không
// có panel trắng như bảng cài đặt), nên dùng màu kem sáng như tiêu đề chính cho
// nổi, kèm chút bóng đổ cho rõ chữ. Màu nâu cũ bị chìm hẳn vào nền.
export const panelHeading = {
    fontFamily: "Broline",
    color: "#f2d7b3",
    fontSize: 18,
    marginBottom: 6,
    textShadow: "0 1px 3px rgba(0,0,0,0.45)"
};

export const chip = {
    flex: "0 0 auto",
    padding: "6px 14px",
    fontSize: 16,
    fontFamily: "Broline",
    color: "#8c5b4a",
    background: "white",
    border: "2px solid #e2c8bf",
    borderRadius: 999,
    cursor: "pointer",
    whiteSpace: "nowrap",
    transition: "background 0.15s ease, border-color 0.15s ease"
};

export const chipActive = {
    borderColor: "#ff7aa2",
    background: "#fff0f4"
};
